import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import { connect } from 'react-redux'
import { resetPassword } from 'reducers/user/userActions'
import { showErrorMessage } from 'reducers/application/applicationActions'
import history from 'utils/History/history';

import { NOT_AUTHENTICATED_HOME } from 'routes/routesConstants';

import jwt_decode from 'jwt-decode';

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHidden: true,
      password: "",
      repeatPassword: "",
      passwordError: null,
      repeatPasswordError: null,
      token: null,
      userName: ""
    };
  }

  componentWillMount() {
    const queryParams = this.props.location.search;
    const params = new URLSearchParams(queryParams.replace("?", ""));

    const token = params.get('token');
    if (token != null && token !== "") {
      var jwtDecoded = jwt_decode(token);
      this.setState({
        token: token,
        userName: jwtDecoded.sub
      });
    } else {
      setTimeout(
        function () {
          this.props.showErrorMessage("URL de restablecer contraseña inválido");
          history.push(NOT_AUTHENTICATED_HOME);
        }.bind(this),
        700
      );
    }
  }

  componentDidMount() {
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }

  handlePasswordChange(event) {
    const value = event.target.value;
    this.setState({
      password: value
    });
    value.length < 6
      ? this.setPasswordError()
      : this.setState({ passwordError: null });
  }

  handleRepeatPasswordChange(event) {
    const value = event.target.value;
    this.setState({
      repeatPassword: value
    });
    value !== this.state.password
      ? this.setRepeatPasswordError()
      : this.setState({ repeatPasswordError: null });
  }

  setPasswordError() {
    this.setState({
      passwordError: (
        <small className="text-danger">
          Su contraseña debe tener al menos 6 caracteres
          </small>
      )
    })
  }

  setRepeatPasswordError() {
    this.setState({
      repeatPasswordError: (
        <small className="text-danger">
          Las contraseñas no coinciden
          </small>
      )
    })
  }

  handleSetPassword() {
    if (this.state.password.length == 0) {
      this.setPasswordError(); return;
    } else {
      this.setState({ passwordError: null });
    }
    if (this.state.password !== this.state.repeatPassword) {
      this.setRepeatPasswordError(); return;
    } else {
      this.setState({ repeatPasswordError: null });
    }

    let data = {
      token: this.state.token,
      password: this.state.password,
      repeatPassword: this.state.repeatPassword
    }

    this.props.resetPassword(data, this.state.userName);
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col md={4} sm={6} mdOffset={4} smOffset={3}>
            <form>
              <Card
                hidden={this.state.cardHidden}
                textCenter
                title="Establecer contraseña"
                content={
                  <div>
                    <FormGroup>
                      <ControlLabel>Contraseña</ControlLabel>
                      <FormControl
                        placeholder="Ingresa Contraseña"
                        name="user"
                        type="password"
                        onChange={event => this.handlePasswordChange(event)}
                      />
                      {this.state.passwordError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Repetir Contraseña</ControlLabel>
                      <FormControl
                        placeholder="Repetir Contraseña"
                        name="password"
                        type="password"
                        onChange={event => this.handleRepeatPasswordChange(event)}
                      />
                      {this.state.repeatPasswordError}
                    </FormGroup>
                  </div>
                }
                legend={
                  <Button
                    bsStyle="info"
                    fill
                    wd
                    onClick={this.handleSetPassword.bind(this)}
                  >
                    Enviar
                  </Button>
                }
                ftTextCenter
              />
            </form>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect(null,
  { resetPassword, showErrorMessage }
)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPasswordPage.jsx